export const navScrollbar = {
  '::-webkit-scrollbar': {
    height: '6px',
    width: '6px'
  },
  '::-webkit-scrollbar-thumb': {
    background: 'utility.200',
    borderRadius: 'full'
  },
  '::-webkit-scrollbar-track': {
    background: 'utility.100',
    borderRadius: 'full'
  },

  _hover: {
    '::-webkit-scrollbar-thumb': {
      background: 'utility.400'
    },
    '::-webkit-scrollbar-track': {
      background: 'utility.100'
    }
  },

  _dark: {
    '::-webkit-scrollbar-thumb': {
      background: 'whiteAlpha.100',
      borderRadius: 'full'
    },
    '::-webkit-scrollbar-track': {
      background: 'whiteAlpha.50',
      borderRadius: 'full'
    },

    _hover: {
      '::-webkit-scrollbar-thumb': {
        background: 'whiteAlpha.300'
      },
      '::-webkit-scrollbar-track': {
        background: 'whiteAlpha.100'
      }
    }
  }
};
